import React, { useState, useEffect} from "react";
import {
  Box,
  Flex,
  Text,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Button,
  IconButton,Select,Tooltip,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "@chakra-ui/react";
import { ArrowBackIcon, DeleteIcon,RepeatIcon } from "@chakra-ui/icons";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useToast } from "@chakra-ui/react";
import {  getExpertsGroupsADP, getExpertsInGroupADP, initSurveyService } from "../../../services/http/surveyHttpService";
import { useSession } from "../../../SessionContext";
import logout from "../../../services/authService";
import createAxiosInstance from "../../../interceptors/useAxiosInterceptors";
import { useNavigate } from "react-router-dom";
import { getExpertsADP } from "../../../services/http/surveyHttpService";
import { createExpertsGroupADP } from "../../../services/http/surveyHttpService";
import { MdGroupAdd } from "react-icons/md";
import { MdGroupRemove } from "react-icons/md";
import { useTranslation } from "react-i18next";

const ITEM_TYPE = "EXPERT";







const DraggableExpert = ({ expert }) => {
  const {t} = useTranslation();
  const [, dragRef] = useDrag({
    type: ITEM_TYPE,
    item: { expert },
  });

  return (
    <Box
      ref={dragRef}
      p={3}
      m={2}
      bg="blue.100"
      borderRadius="md"
      border="1px solid"
      borderColor="blue.300"
      cursor="pointer"
    >
      <Text fontWeight="bold">
        {expert.name} {expert.surname}
      </Text>
      <Text fontSize="sm">{t('survey.createGroup.role')}: {expert.role}</Text>
    </Box>
  );
};

const DroppableArea = ({ selectedExperts,expertsOfGroupSelectedCopy, setSelectedExperts,setExperts,setExpertsOfGroupSelected, handleSaveGroup,onOpenModalDiscardChangesGroup}) => {
  const {t} = useTranslation();
  const [{ isOver }, dropRef] = useDrop({
    accept: ITEM_TYPE,
    drop: (item) => {


      

      setSelectedExperts((prev) => {
        // Verifica se l'esperto è già presente
        const exists = prev.some((e) => e.expert_id === item.expert.expert_id);
        
        if(exists) {
          return prev
          
    
          
        }else {
          if(item.expert.isOfGruop) {
            setExpertsOfGroupSelected((prevExperts) => prevExperts.filter((expert) => expert.expert_id !== item.expert.expert_id));
          }else {
            setExperts((prevExperts) => prevExperts.filter((expert) => expert.expert_id !== item.expert.expert_id));
          }
          return [...prev, item.expert]
        }

      });


      setSelectedExperts((prev) =>
        prev.sort((a, b) => 
          a.name.localeCompare(b.name)
      ));
      


    
        
      

     

      
      
    },
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  });

  const handleRemoveExpert = (expert) => {
    setSelectedExperts((prev) => prev.filter((expertRes) => expertRes.expert_id !== expert.expert_id));

    if(expert.isOfGruop) {
      if (expertsOfGroupSelectedCopy.some(expertRes => expertRes.expert_id === expert.expert_id)) {
      setExpertsOfGroupSelected((prev) => [...prev, expert]);
      setExpertsOfGroupSelected((prev) => prev.sort((a, b) => 
        a.name.localeCompare(b.name)
      ));
    }

    }else {


      
      

      setExperts((prev) => [...prev, expert]);
      setExperts((prev) => prev.sort((a, b) => 
        a.name.localeCompare(b.name)
      ));


      
    }

  };

  return (
    <Box
      ref={dropRef}
      p={4}
      border="2px dashed"
      borderColor={isOver ? "blue.500" : "gray.300"}
      borderRadius="md"
      bg={isOver ? "blue.50" : "gray.50"}
      minH="440px"
      maxH="440px"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
    >
      <Box position="sticky" top="0" bg="white" zIndex="1" borderRadius="md" p={1} mb={2}>
        <Text fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>
          {t('survey.createGroup.selectedExperts')}

          <Tooltip label={t('toolTip.tooltipSurvey.expertGroups.createGroup.createGroupActions.removeAllExperts')} placement="bottom">

<IconButton
ml={"4%"}
aria-label="Refresh experts"
icon={<MdGroupRemove size={25}/>} // Imposta l'icona
size="sm"
colorScheme="blue"
onClick={()=> {
  let expertsOfGroup = selectedExperts.filter(expert =>expert.isOfGruop)
  let expertsWithoutGroup = selectedExperts.filter(expert =>!expert.isOfGruop)

  if(expertsOfGroup != null && expertsOfGroup.length >0) {

    
    setExpertsOfGroupSelected((prev) => [...prev, ...expertsOfGroup])

    setExpertsOfGroupSelected((prev) =>
      prev.sort((a, b) => 
        a.name.localeCompare(b.name)
      ));
  }

  
  if(expertsWithoutGroup != null && expertsWithoutGroup.length >0) {
   
    setExperts((prev) => [...prev, ...expertsWithoutGroup])
    setExperts((prev) =>
      prev.sort((a, b) => 
        a.name.localeCompare(b.name)
      ));
  }
  


  setSelectedExperts([])


  
  




}} // Funzione per gestire il refresh
/></Tooltip>

        </Text>
      </Box>
      <Box overflowY="auto" maxH="310px">
        {selectedExperts.map((expert) => (
          <Box
            key={expert.expert_id}
            p={3}
            m={2}
            bg="green.100"
            borderRadius="md"
            border="1px solid"
            borderColor="green.300"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box>
              <Text fontWeight="bold">
                {expert.name} {expert.surname}
              </Text>
              <Text fontSize="sm">{t('survey.createGroup.role')}: {expert.role}</Text>
              
              <Text fontSize="sm">H-Index: {expert.h_index}</Text>
            </Box>
            <IconButton
              icon={<DeleteIcon />}
              colorScheme="red"
              size="sm"
              onClick={() => handleRemoveExpert(expert)}

             
            />
          </Box>
        ))}
      </Box>
      <Box mt={4}>
  <Flex justifyContent="space-between" alignItems="center">
    <Tooltip label="GoBack" aria-label="Reset Tooltip">
      <IconButton
        icon={<ArrowBackIcon boxSize={6} />}
        colorScheme="red"
        aria-label="GoBack"
        onClick={() => {
          onOpenModalDiscardChangesGroup();
        }}
        size="lg"
      />
    </Tooltip>
    
    <Button
      colorScheme="blue"
      size="lg"
      width="auto"
      onClick={() => handleSaveGroup()}
    >
      {t('survey.createGroup.saveGroup')}
    </Button>
  </Flex>
</Box>
    </Box>
  );
};

const CreateGroupComponent = () => {
  const {t} = useTranslation();
  const toast = useToast();
  const [experts, setExperts] = useState([]);
  const [expertsCopy, setExpertsCopy] = useState([]);
  const [expertsOfGroupSelected, setExpertsOfGroupSelected] = useState([]);
  const [expertsOfGroupSelectedCopy, setExpertsOfGroupSelectedCopy] = useState([]);

  const [groups, setGroups] = useState([]);
  const [selectedExperts, setSelectedExperts] = useState([]);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  const [searchQueryExpert, setSearchQueryExpert] = useState('');

  const [searchQueryExpertOfGroupSelected, setSearchQueryExpertOfGroupSelected] = useState('');


  const { 
    isOpen: isOpenModalDiscardChangesGroup, 
    onOpen: onOpenModalDiscardChangesGroup, 
    onClose: onCloseModalDiscardChangesGroup 
  } = useDisclosure();  


  const { updateSessionData, clearSessionData} = useSession();

  const navigate = useNavigate();



  const axiosInstance = createAxiosInstance(async (axiosInstance)=> {

    logout(t, clearSessionData,navigate,toast,axiosInstance)
  });

  initSurveyService(t, toast, axiosInstance)
  

  useEffect(() => {
  
    
    populateExpertData()
    populateGroupData()
   
  }, []);


  const populateExpertData=()=> { 
    getExpertsADP({username: sessionStorage.getItem("username")}).then(res => {
     
      if (res != null && res.experts != null && res.experts.length > 0) {

        res.experts.forEach(expert => {
          expert.isOfGruop = false;
        })

        const sortedExperts = res.experts
        .filter(resExpert => resExpert.has_consensus)
        .sort((a, b) => 
          a.name.localeCompare(b.name)
        );

        setExperts(sortedExperts);
        setExpertsCopy(sortedExperts)
      }
    });
  }

  const populateGroupData=()=> {

   

    

    getExpertsGroupsADP(sessionStorage.getItem("username")).then(res => {

      if(res != null && res.expertsGroups != null  && res.expertsGroups.length >0) {
        const sortedGroups = res.expertsGroups.sort((a, b) => 
          a.title.localeCompare(b.title)
        );
          
        setGroups(sortedGroups)
      }
      
        if(res.expertsGroups &&  res.expertsGroups[0] &&  res.expertsGroups[0].expert_group_id) {
          getExpertsInGroupADP({groupId: res.expertsGroups[0].expert_group_id}).then(res => {

            if(res != null && res.experts != null && res.experts.length >0)
              
              res.experts.forEach(expert => {
                expert.isOfGruop = true;
              })
              
  
              const sortedExperts = res.experts.sort((a, b) => 
                a.name.localeCompare(b.name)
              );
            setExpertsOfGroupSelected(sortedExperts)
            setExpertsOfGroupSelectedCopy(sortedExperts)
  
            
          }) 
        }
        
      
      
    })
  }

  const handleSaveGroup = () => {
    console.log(selectedExperts)
    if (!title || !description || selectedExperts.length === 0) {
      toast({
        title: t('toastMsg.createGroup.fillInAllFieldsAndSelectAtLeastOneExpertGroup'),
        status: "warning",
        isClosable: true,
      });
      return;
    }

    const body = {
      title,
      description,
      owner: sessionStorage.getItem("username"),
      experts: selectedExperts.map((expert) => expert.expert_id),
    };
    console.log(body)
    createExpertsGroupADP(body)
      .then((res) => {

        populateExpertData();
        populateGroupData()
        toast({
          title: res.message,
          status: "success",
          isClosable: true,
          duration: 2000,
          onCloseComplete : ()=> {
            navigate("/groups?hideHeader=true&hideNavbar=true")
          }
        });

        setTitle("");
        setDescription("");
        setSelectedExperts([]);
      })
      .catch(() => {
        toast({
          title: t('toastMsg.createGroup.errorSavingGroup'),
          status: "error",
          isClosable: true,
          duration: 2300,
          onCloseComplete : ()=> {
            navigate("/groups?hideHeader=true&hideNavbar=true")
          }
        });
      });
  };

  return (

    
    <Box p={4} overflowY="auto" bgColor={"#f6f3ec"}>


        <Modal onClose={onCloseModalDiscardChangesGroup} isOpen={isOpenModalDiscardChangesGroup} isCentered closeOnOverlayClick={false} >
                            <ModalOverlay />
                            <ModalContent>
                              <ModalHeader>   {t('survey.confirmExitUpdateSurveyWithoutSavingMessage')} </ModalHeader>
                              <ModalBody></ModalBody>
                              <ModalFooter>
                                <Button colorScheme='green' mr={3} onClick={()=> {
                                
                                 navigate("/groups?hideHeader=true&hideNavbar=true")
                                
                                 
                                }}>
                                   {t('survey.tableGroup.yes')}
                                </Button>
                                <Button colorScheme='red' onClick={onCloseModalDiscardChangesGroup}>
                                  No
                                </Button>
                              </ModalFooter>
                            </ModalContent>
                          </Modal>
    <Box maxW="500px" mx="auto">
      <Text fontSize="2xl" fontWeight="bold" mb={4} color={"rgba(11,78,90,255)"}>
      {t('survey.createGroup.createGroupAndAssignExperts')}
      </Text>
      <FormControl mb={4} isRequired>
        <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>{t('survey.createGroup.title')}</FormLabel>
        <Input
          bg="white"
          placeholder={t('survey.createGroup.enterGroupTitle')}
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
      </FormControl>
      <FormControl mb={4} isRequired>
        <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>{t('survey.createGroup.description')}</FormLabel>
        <Textarea
          bg="white"
          placeholder={t('survey.createGroup.enterGroupDescription')}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </FormControl>
      
    </Box>
      <DndProvider backend={HTML5Backend}>
        <Flex direction={{ base: "column", md: "row" }} gap={4} justifyContent="center" wrap="wrap">
          <Box flex={5} maxH="440px" border="1px solid gray" borderRadius="md" p={4} w={{ base: "90%", md: "45%" }} maxW="400px" mx={{ base: "auto", md: "0" }}>
            <Box position="sticky" top="0" zIndex="1">
              <Text fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold' mb={2}>
              {t('survey.createGroup.availableExperts')}
              
                <Tooltip label={t('toolTip.tooltipSurvey.expertGroups.createGroup.createGroupActions.refreshExpertList')} placement="bottom">

                <IconButton
                ml={"4%"}
    aria-label="Refresh experts"
    icon={<RepeatIcon />} // Imposta l'icona
    size="sm"
    colorScheme="blue"
    onClick={()=> {

     populateExpertData()

    }} // Funzione per gestire il refresh
  /></Tooltip>


                <Tooltip label={t('toolTip.tooltipSurvey.expertGroups.createGroup.createGroupActions.addAllExperts')} placement="bottom">

<IconButton
ml={"4%"}
aria-label="Refresh experts"
icon={<MdGroupAdd size={25}/> } // Imposta l'icona
size="sm"
colorScheme="blue"
onClick={()=> {

  


 


  setSelectedExperts((prev) => {
    // Unisci il vecchio stato con gli esperti selezionati
    const combinedExperts = [...prev, ...experts];
  
    // Rimuovi i duplicati basati su 'expert_id'
    const uniqueExperts = combinedExperts.filter((expert, index, self) =>
      index === self.findIndex((e) => e.expert_id === expert.expert_id)
    );
  
    return uniqueExperts;
  });


  setSelectedExperts((prev) =>
    prev.sort((a, b) => 
      a.name.localeCompare(b.name)
    ));

  setExperts([])  

}} // Funzione per gestire il refresh
/></Tooltip>
              </Text>
 

              <Input
              bg="white"
              placeholder={t('survey.createGroup.searchExpertByName')}
              value={searchQueryExpert}
              onChange={(e) => {
            
              setSearchQueryExpert(e.target.value);


            
              setExperts(expertsCopy.filter((expert) => expert.name.toLowerCase().includes(searchQueryExpert.toLowerCase())));
            
            }}
          mb={2}
        />
            </Box>
            <Box overflowY="auto" maxH="310px">
              {experts.map((expert) => (
                <DraggableExpert key={expert.expert_id} expert={expert} />
              ))}
            </Box>
          </Box>

          <Box flex={4.5} w={{ base: "90%", md: "45%" }} maxW="400px" mx={{ base: "auto", md: "0" }} // Aumenta il valore flex per renderlo più largo
>
            <DroppableArea
              selectedExperts={selectedExperts}
              setSelectedExperts={setSelectedExperts}
              handleSaveGroup={handleSaveGroup}
              onOpenModalDiscardChangesGroup={onOpenModalDiscardChangesGroup}
              expertsOfGroupSelectedCopy={expertsOfGroupSelectedCopy}

              setExperts={setExperts}
              setExpertsOfGroupSelected={setExpertsOfGroupSelected}
              experts={experts}
              expertsOfGroupSelected={expertsOfGroupSelected}
            />
          </Box>
          
          {groups && groups.length > 0? (  <Box flex={6} maxH="440px"  border="1px solid gray" borderRadius="md" p={4} w={{ base: "90%", md: "45%" }} maxW="400px" mx={{ base: "auto", md: "0" }}>
            <Box position="sticky" top="0" zIndex="1">
              
            <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>{t('survey.createGroup.selectGroup')}:

                <Tooltip label={t('toolTip.tooltipSurvey.expertGroups.createGroup.createGroupActions.refreshGroupList')} placement="bottom" closeOnClick={true}>
                  <span>

<IconButton
ml={"14%"}
aria-label="Refresh groups"
icon={<RepeatIcon />} // Imposta l'icona
size="sm"
colorScheme="blue"
onClick={()=> {

populateGroupData()

}} // Funzione per gestire il refresh
/>
</span>
</Tooltip>
            </FormLabel>
                    <Select bg="white" onChange={(e) => {
                      
                        
                      setExpertsOfGroupSelected([])

                      getExpertsInGroupADP({groupId: e.target.value}).then(res => {

                          if(res != null && res.experts != null && res.experts.length >0)

                            res.experts.forEach(expert => {
                              expert.isOfGruop = true;
                            })
                        setExpertsOfGroupSelected(res.experts)
                        setExpertsOfGroupSelectedCopy(res.experts)
                    }) 
                    

                    }} >
                     
                    
                      {groups.map(option => (
                        <option key={option.expert_group_id} value={option.expert_group_id}>
                        {option.title}
                        </option>
                      ))}
                     
                    </Select>
              

                    <Input  
                    bg="white"
                    width="200px"
          placeholder={t('survey.createGroup.searchExpertByName')}
          value={searchQueryExpertOfGroupSelected}
          onChange={(e) => { 
            setSearchQueryExpertOfGroupSelected(e.target.value)

            setExpertsOfGroupSelected(expertsOfGroupSelectedCopy.filter((expert) => expert.name.toLowerCase().includes(searchQueryExpertOfGroupSelected.toLowerCase())));

          }}
          my={2}
        />
      <Tooltip label={t('survey.createGroup.addAllExperts')} aria-label={t('survey.createGroup.addAllExperts')}>

<IconButton
ml={"4%"}
aria-label="Refresh experts"
icon={<MdGroupAdd size={25}/> } // Imposta l'icona
size="sm"
colorScheme="blue"
onClick={()=> {

  
  console.log(experts)
  console.log(expertsOfGroupSelected)

  setSelectedExperts((prev) => {
    // Unisci il vecchio stato con gli esperti selezionati
    const combinedExperts = [...prev, ...expertsOfGroupSelected];
  
    // Rimuovi i duplicati basati su 'expert_id'
    const uniqueExperts = combinedExperts.filter((expert, index, self) =>
      index === self.findIndex((e) => e.expert_id === expert.expert_id)
    );
  
    return uniqueExperts;
  });

  setSelectedExperts((prev) =>
    prev.sort((a, b) => 
      a.name.localeCompare(b.name)
    ));

  setExpertsOfGroupSelected([])  

}} // Funzione per gestire il refresh
/></Tooltip>
              <Text fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold' mb={2}>
                {t('survey.createGroup.availableExpertsOfGroupSelected')}


          

              </Text>
                      

          
             


            </Box>
            <Box overflowY="auto" maxH="310px">
              {expertsOfGroupSelected.map((expert) => (
                <DraggableExpert key={expert.expert_id} expert={expert} />
              ))}



            </Box>
          </Box>): ("")}  
        </Flex>
      </DndProvider>


  

    </Box>
  );
};

export default CreateGroupComponent;
